import { useRouter } from 'vue-router';

let _router: ReturnType<typeof useRouter> | null = null;

export function initAppNavigation(router: ReturnType<typeof useRouter>) {
  _router = router;

  // Expose globally for components that can't use composables directly
  (globalThis as any).navigateToTrack = navigateToTrack;
  (globalThis as any).navigateToWorkplaces = navigateToWorkplaces;
  (globalThis as any).navigateToPlanner = navigateToPlanner;
}

function navigateToTrack() {
  _router?.push({ name: 'track' });
}

function navigateToWorkplaces() {
  _router?.push({ name: 'workplaces' });
}

function navigateToPlanner() {
  _router?.push({ name: 'planner' });
}
